export const GET_ANGULAR_MISALIGNMENT_HSS_RESULT = "GET_ANGULAR_MISALIGNMENT_HSS_RESULT";
export const GET_ANGULAR_MISALIGNMENT_HSS_RESULT_SUCCESS = "GET_ANGULAR_MISALIGNMENT_HSS_RESULT_SUCCESS";
export const GET_ANGULAR_MISALIGNMENT_HSS_RESULT_ERROR = "GET_ANGULAR_MISALIGNMENT_HSS_RESULT_ERROR";
export const RESET_ANGULAR_MISALIGNMENT_HSS_RESULT = "RESET_ANGULAR_MISALIGNMENT_HSS_RESULT";
